import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';
import TimeframePicker from '@components/TimeframePicker';
import { Select } from '@components/Select';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
    },
    '& .modal-base-content': {
        padding: 16,
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '16px 24px',
    gridTemplateColumns: 'repeat(2, 1fr)',
    '@media (max-width: 600px)': {
        gridGap: '16px',
    },
    '& .combo-location-select': {
        gridColumn: '1 / span 2',
        '& .location-type': {
            marginTop: '-16px',
        },
    },
});

export const StyledTimeframePicker = styled(TimeframePicker)({
    '@media (max-width: 600px)': {
        gridColumn: '1 / span 2',
    },
    '& .react-datepicker': {
        display: 'flex',
    },
});

export const StyledSelect = styled(Select)({
    '@media (max-width: 600px)': {
        gridColumn: '1 / span 2',
    },
});

export const CtaWrapper = styled('div')({
    gridColumn: '1 / span 2',
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: '16px 24px',
    '@media (max-width: 600px)': {
        gridTemplateColumns: '1fr',
        gridGap: '16px',
    },
});
